import React from "react";
import { cn } from "@/utils/cn";

interface OverlayProps {
  children: React.ReactNode;
  className?: string;
  showOnHover?: boolean;
}

export const TopLeft: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
}) => (
  <div
    className={cn(
      "absolute top-2 left-2 z-20",
      showOnHover && "opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      className
    )}
  >
    {children}
  </div>
);

export const TopRight: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
}) => (
  <div
    className={cn(
      "absolute top-2 right-2 z-20 flex gap-1.5",
      showOnHover && "opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      className
    )}
  >
    {children}
  </div>
);

export const BottomLeft: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
}) => (
  <div
    className={cn(
      "absolute bottom-2 left-2 z-20",
      showOnHover && "opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      className
    )}
  >
    {children}
  </div>
);

export const BottomRight: React.FC<OverlayProps> = ({
  children,
  className,
  showOnHover = false,
}) => (
  <div
    className={cn(
      "absolute bottom-2 right-2 z-20",
      showOnHover && "opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      className
    )}
  >
    {children}
  </div>
);
